import React from "react";
import Grid from '@mui/material/Grid2';
import Typography from "@common/components/Typography";
import { Info } from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import { DeviceStatusType, getStatusSxColorFn } from "../const";

type DeviceCardFooterProps = {
  label: string;
  status?: DeviceStatusType;
  tooltip?: string;
};

const DeviceCardFooter = (props: DeviceCardFooterProps) => {
  const { label, status = "default", tooltip } = props;

  return (
    <Grid
      container
      sx={[{
        justifyContent: "center",
        alignItems: "center",
        gap: "0.5rem"
      }, (theme) => ({
        textAlign: "center",
        color: theme.palette.common.white,
        width: "100%",
        backgroundColor: getStatusSxColorFn(status),
        "& .MuiTypography-root": {
          textTransform: "uppercase",
        },
      })]}>
      <Typography
        size="small"
       
        sx={[
          status === "unknown"
            ? (theme) => ({
                color: theme.palette.common.grey.gBFBFBF,
              })
            : {},
            {
              fontWeight:500
            }
        ]}
      >
        {label}
      </Typography>
      {tooltip && (
        <Tooltip title={tooltip} arrow>
          <Info />
        </Tooltip>
      )}
    </Grid>
  );
};

export default DeviceCardFooter;
